import { Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { Send } from '@material-ui/icons/';
import React from 'react';
import { Auto, Text } from './controls';
import { Message, MessageApi, MessageThread } from './message-api';
import { darkBlue, lightGrayBlue, mediumGray, mediumGrayBlue } from './theme';
import { configApi } from './config';

const width = { width: '100%' };

const radius = '14px';
const receivedBorder = {
  color: darkBlue,
  backgroundColor: lightGrayBlue,
  borderRadius: `${radius} ${radius} ${radius} 0px`,
};

const replyBorder = {
  color: 'white',
  backgroundColor: mediumGrayBlue,
  borderRadius: `${radius} ${radius} 0px ${radius}`,
};

const systemBorder = {
  color: darkBlue,
  backgroundColor: 'white',
  border: 'solid 1px ' + darkBlue,
  borderRadius: `${radius} ${radius} ${radius} 0px`,
};

export function MessageBubble(props: Message) {
  const { type, sender, message, timestamp } = props;

  const isSystemUser = sender === configApi.getState().config.systemUser;;

  const border =
    type === 'reply'
      ? replyBorder
      : type === 'received'
      ? receivedBorder
      : systemBorder;
  return (
    <Grid
      item
      container
      direction="column"
      style={{ ...width, ...{ paddingRight: 0 } }}
      spacing={1}
    >
      <Grid
        item
        container
        direction="row"
        style={{ ...width, ...{ color: mediumGrayBlue } }}
      >
        <Grid item>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 'bold', fontSize: 11 }}
          >
            {isSystemUser ? "System User" : 
            type === 'system' ? 'System' : sender}
          </Typography>
        </Grid>
        <Grid item style={{ flexGrow: 1 }}></Grid>
        <Grid item>
          <Typography variant="subtitle2" style={{ fontSize: 11 }}>
            {timestamp}
          </Typography>
        </Grid>
      </Grid>
      <Grid item style={{ ...width, ...border }}>
        <Typography
          variant="subtitle2"
          dangerouslySetInnerHTML={{ __html: message }}
          style={{ paddingLeft: 8, paddingRight: 8 }}
        ></Typography>
      </Grid>
    </Grid>
  );
}

const dividerStyle = { ...width, ...{ backgroundColor: mediumGray } };
function DaySeparator({ dayChange }) {
  return (
    <Grid
      item
      container
      direction="row"
      style={{
        ...width,
        ...{
          color: mediumGray,
        },
      }}
      alignItems="center"
    >
      <Grid item style={{ flexGrow: 1 }}>
        <Divider orientation="horizontal" style={dividerStyle} />
      </Grid>
      <Grid item>
        <Typography variant="subtitle2" style={{ margin: 8 }}>
          {dayChange}
        </Typography>
      </Grid>
      <Grid item style={{ flexGrow: 1 }}>
        <Divider orientation="horizontal" style={dividerStyle} />
      </Grid>
    </Grid>
  );
}

export function MessageList(props: MessageThread) {
  return (
    <Grid
      item
      container
      direction="column"
      style={{
        ...width,
        ...{
          paddingRight: 0,
        },
      }}
      spacing={1}
    >
      {props.messages.map((v, i) => (
        <React.Fragment key={i}>
          {v.dayChange && <DaySeparator dayChange={v.dayChange} />}
          <MessageBubble {...v} />
        </React.Fragment>
      ))}
    </Grid>
  );
}

function Reply(api: MessageApi) {
  const { reply } = api.forms;
  const { message } = reply.controls;
  return (
    <Grid
      item
      container
      direction="row"
      style={{
        ...width,
        ...{
          borderTop: 'solid 1px ' + mediumGray,
          paddingTop: 12,
          paddingRight: 0,
        },
      }}
      alignItems="center"
      spacing={0}
    >
      <Grid item style={{ flexGrow: 1 }}>
        <Text {...message} />
      </Grid>

      <Grid item>
        <IconButton onClick={() => reply.submit()}>
          <Send color="primary" />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export function MessageEntry(api: MessageApi) {
  const thread = api.data((s) => s.selected);
  const messages = thread?.messages;


  return (
    thread &&
    !!messages?.length && (
      <Grid
        container
        direction="column"
        style={{
          width: 366,
          flexShrink: 0,
          flexWrap: 'nowrap',
          height: '86vh',
          paddingTop: 12,
          paddingLeft: 24,
          paddingRight: 12,
          overflowY: 'auto',
        }}
        spacing={2}
      >
        <Grid item style={width}>
          <Auto {...api.forms.filter.controls.filter} />
        </Grid>
        <Grid
          item
          style={{
            flexGrow: 1,
            flexWrap: 'nowrap',
            maxHeight: '80vh',
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <MessageList messages={messages} />
        </Grid>
      </Grid>
    )
  );
}

//TODO: add reply
// <Reply {...api} />
